<template>
  <div>
    <!-- 不良数据 -->
    <el-dialog :visible.sync="dialogVisible" width="1600px" :title="$t('message.detail')">
      <div class="table">
        <ol>
          <!-- 订单号 -->
          <li class="flex15 color1">{{ $t('message.orderNumber') }}</li>
          <!-- 番号 -->
          <li class="color1">{{ $t('message.mash') }}</li>
          <!-- 购买数量 -->
          <li class="color1">{{ $t('message.PurchaseQuantity') }}</li>
          <!-- 不良产生时间 -->
          <li>{{ $t('message.DefectOccurrenceTime') }}</li>
          <!-- 不良数量 -->
          <li>{{ $t('message.NumberOfDefects') }}</li>
          <!-- 不良说明 -->
          <li>{{ $t('message.DefectDescription') }}</li>
          <!-- 不良图片 -->
          <li class="flex3">{{ $t('message.DefectImage') }}</li>
          <!-- 处理决策 -->
          <li>{{ $t('message.HandlingDecision') }}</li>
          <!-- 处理完成时间 -->
          <li>{{ $t('message.HandlingCompletionTime') }}</li>
          <!-- 调整后数量 -->
          <li class="color2">{{ $t('message.AdjustedQuantity') }}</li>
          <!-- 采购单价 -->
          <li>{{ $t('message.PurchaseUnitPrice') }}</li>
          <!-- 调整后单价 -->
          <li class="color2">{{ $t('message.AdjustedUnitPrice') }}</li>

          <!-- 国内运费 -->
          <li>{{ $t('message.domesticFreight') }}</li>
          <!-- 调整后国内运费 -->
          <li class="color2">{{ $t('message.AdjustedDomesticShipping') }}</li>

        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <!-- 订单号 -->
          <li class="flex15 color1">
            <router-link :to="'/orderDetail?order_sn=' + item.order_sn" class="a-link" target="_blank">
              {{ item.order_sn }}
            </router-link>
          </li>
          <!-- 番号 -->
          <li class="color1">{{ item.sorting }}</li>
          <!-- 购买数量 -->
          <li class="color1">{{ item.offer_num_bak }}</li>
          <!-- 不良产生时间 -->
          <li>{{ item.created_at }}</li>
          <!-- 不良数量 -->
          <li>{{ item.num }}</li>
          <!-- 不良说明 -->
          <li>{{ item.description_translate }}</li>
          <!-- 不良图片 -->
          <li class="flex3">
            <div class="pic">
              <el-image style="width: 100px; height: 100px" :src="pic" :preview-src-list="[pic]"
                v-for="(pic, picIndex) in item.problem_goods_image" :key="picIndex">
              </el-image>
            </div>
          </li>
          <!-- 处理决策 -->
          <li>{{ item.client_deal }}</li>
          <!-- 处理完成时间 -->
          <li>{{ item.p_deal_at }}</li>
          <!-- 调整后数量 -->
          <li class="color2">{{ item.pre_num }}</li>
          <!-- 采购单价 -->
          <li>{{ item.offer_price_bak }}</li>
          <!-- 调整后单价 -->
          <li class="color2">{{ item.pre_price }}</li>

          <!-- 国内运费 -->
          <li>{{ item.offer_freight_bak }}</li>
          <!-- 调整后国内运费 -->
          <li class="color2">{{ item.pre_freight }}</li>

        </ul>
        <div class="nodata" v-if="tableData == false">
          无数据
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      tableData: [],
    };
  },
  methods: {
    problemListDetail(skuCodes, user_id) {
      let datas = {
        user_id,
        skuCodes,
      }
      this.$api.productManagementApi.problemListDetail(datas).then(res => {
        this.tableData = res.data
        this.dialogVisible = true
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.table {
  padding: 0 20px;

  .color1 {
    background-color: rgba(250, 205, 145, 0.584313725490196);
  }

  .color2 {
    background-color: rgba(236, 128, 141, 0.196078431372549);
  }

  .color3 {
    background-color: rgba(129, 211, 248, 0.196078431372549)
  }

  .flex3 {
    flex: 3
  }

  .flex15 {
    flex: 2;
  }

  li {
    text-align: center;
  }

  ul {
    padding: 0;

    li {
      padding: 10px 0;
    }
  }

  .nodata {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
  }
}
</style>